import { AppDescription } from '@/components/atoms/AppDescription/AppDescription'
import { AppTitle } from '@/components/atoms/AppTitle/AppTitle'
import { Button, Flex, Modal } from 'antd'
import React from 'react'

type Props = {
  onClose: () => void;
  open: boolean;
}

export function AuthLedgerNotAvailable({ open, onClose }: Props) {
  return (
    <Modal
      rootClassName="errorLedgerModal"
      onCancel={onClose}
      open={open}
      footer={null}
      title={null}
      transitionName={null}
      maskTransitionName={null}
    >
      <Flex justify="center" align="center" gap={30} vertical>
        <svg width="250" height="62" viewBox="0 0 250 62" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect
            x="1.5"
            y="1.5"
            width="247"
            height="59"
            rx="10.5"
            stroke="#7A72FF"
            strokeOpacity="0.3"
            strokeWidth="3"
          />
          <path
            d="M26.7713 22H31.2287L30.7659 31H27.2585L26.7713 22ZM26.7713 40L27.2341 31H30.7659L31.2287 40H26.7713ZM20 28.189L22.2165 24.811L29.889 29.6535L28.111 32.3465L20 28.189ZM38 28.1654L29.889 32.3228L28.111 29.6535L35.7591 24.811L38 28.1654ZM38 33.8346L35.7591 37.189L28.111 32.3465L29.889 29.6535L38 33.8346ZM20 33.8346L28.111 29.6535L29.889 32.3465L22.2165 37.189L20 33.8346Z"
            fill="#7A72FF"
          />
          <path
            d="M58.7713 22H63.2287L62.7659 31H59.2585L58.7713 22ZM58.7713 40L59.2341 31H62.7659L63.2287 40H58.7713ZM52 28.189L54.2165 24.811L61.889 29.6535L60.111 32.3465L52 28.189ZM70 28.1654L61.889 32.3228L60.111 29.6535L67.7591 24.811L70 28.1654ZM70 33.8346L67.7591 37.189L60.111 32.3465L61.889 29.6535L70 33.8346ZM52 33.8346L60.111 29.6535L61.889 32.3465L54.2165 37.189L52 33.8346Z"
            fill="#7A72FF"
          />
          <path
            d="M90.7713 22H95.2287L94.7659 31H91.2585L90.7713 22ZM90.7713 40L91.2341 31H94.7659L95.2287 40H90.7713ZM84 28.189L86.2165 24.811L93.889 29.6535L92.111 32.3465L84 28.189ZM102 28.1654L93.889 32.3228L92.111 29.6535L99.7591 24.811L102 28.1654ZM102 33.8346L99.7591 37.189L92.111 32.3465L93.889 29.6535L102 33.8346ZM84 33.8346L92.111 29.6535L93.889 32.3465L86.2165 37.189L84 33.8346Z"
            fill="#7A72FF"
          />
          <path
            d="M122.771 22H127.229L126.766 31H123.258L122.771 22ZM122.771 40L123.234 31H126.766L127.229 40H122.771ZM116 28.189L118.217 24.811L125.889 29.6535L124.111 32.3465L116 28.189ZM134 28.1654L125.889 32.3228L124.111 29.6535L131.759 24.811L134 28.1654ZM134 33.8346L131.759 37.189L124.111 32.3465L125.889 29.6535L134 33.8346ZM116 33.8346L124.111 29.6535L125.889 32.3465L118.217 37.189L116 33.8346Z"
            fill="#7A72FF"
          />
          <path
            d="M154.771 22H159.229L158.766 31H155.258L154.771 22ZM154.771 40L155.234 31H158.766L159.229 40H154.771ZM148 28.189L150.217 24.811L157.889 29.6535L156.111 32.3465L148 28.189ZM166 28.1654L157.889 32.3228L156.111 29.6535L163.759 24.811L166 28.1654ZM166 33.8346L163.759 37.189L156.111 32.3465L157.889 29.6535L166 33.8346ZM148 33.8346L156.111 29.6535L157.889 32.3465L150.217 37.189L148 33.8346Z"
            fill="#7A72FF"
          />
          <path
            d="M186.771 22H191.229L190.766 31H187.258L186.771 22ZM186.771 40L187.234 31H190.766L191.229 40H186.771ZM180 28.189L182.217 24.811L189.889 29.6535L188.111 32.3465L180 28.189ZM198 28.1654L189.889 32.3228L188.111 29.6535L195.759 24.811L198 28.1654ZM198 33.8346L195.759 37.189L188.111 32.3465L189.889 29.6535L198 33.8346ZM180 33.8346L188.111 29.6535L189.889 32.3465L182.217 37.189L180 33.8346Z"
            fill="#7A72FF"
          />
          <path
            d="M218.771 22H223.229L222.766 31H219.258L218.771 22ZM218.771 40L219.234 31H222.766L223.229 40H218.771ZM212 28.189L214.217 24.811L221.889 29.6535L220.111 32.3465L212 28.189ZM230 28.1654L221.889 32.3228L220.111 29.6535L227.759 24.811L230 28.1654ZM230 33.8346L227.759 37.189L220.111 32.3465L221.889 29.6535L230 33.8346ZM212 33.8346L220.111 29.6535L221.889 32.3465L214.217 37.189L212 33.8346Z"
            fill="#7A72FF"
          />
        </svg>
        <Flex vertical gap={15}>
          <AppTitle centered text="Unlock Ledger" />
          <AppDescription
            centered
            description={(
              <>
                Enter the PIN code on the Ledger device
                <br />
                and try again
              </>
            )}
          />
        </Flex>
        <Button onClick={onClose} className="mobilePrimaryButton" block type="primary">Got it</Button>
      </Flex>
    </Modal>
  )
}
